import { intlFormatDistance, startOfDay } from "date-fns/esm";
import capitalize from "lodash-es/capitalize";

import { Revision } from "types/generated";
import { unixTimestampToMs } from "utils/time";

const getSpaceliftVcsRepoCommitsSectionLabel = (createdAt: number, now: Date) => {
  return capitalize(intlFormatDistance(startOfDay(createdAt), startOfDay(now), { unit: "day" }));
};

export const groupSpaceliftVcsRepoCommitsByDate = (revisions: Revision[]) => {
  const now = new Date();

  return revisions.reduce<{ label: string; revisions: Revision[] }[]>((sections, revision) => {
    const sectionLabel = getSpaceliftVcsRepoCommitsSectionLabel(
      unixTimestampToMs(revision.createdAt),
      now
    );
    const lastSection = sections.at(-1);

    if (lastSection && lastSection.label === sectionLabel) {
      lastSection.revisions.push(revision);
      return sections;
    }

    return [...sections, { label: sectionLabel, revisions: [revision] }];
  }, []);
};
